import Link from 'next/link'

export const AHeaderHamburgerFooter = () => {
	return (
		<div className='header-hamburger-footer'>
			<div className='header-hamburger-footer__socials'>
				<Link
					href='https://www.facebook.com/klinikamedante'
					title='Facebook'
					target='_blank'
					className='header-hamburger-footer__social facebook'
				>
					<svg className='sicofill'>
						<use href='/assets/layout/icons.svg#s_fb'></use>
					</svg>
				</Link>

				<Link
					href='https://www.instagram.com/poliklinika_medante/'
					title='Instagram'
					target='_blank'
					className='header-hamburger-footer__social instagram'
					prefetch={false}
				>
					<svg className='sicofill'>
						<use href='/assets/layout/icons.svg#s_insta'></use>
					</svg>
				</Link>

				<Link
					href='https://www.linkedin.com/company/medante-poliklinika-celostnej-medic%C3%ADny/'
					title='LinkedIn'
					target='_blank'
					className='header-hamburger-footer__social linkedin'
					prefetch={false}
				>
					<svg className='sicofill'>
						<use href='/assets/layout/icons.svg#s_in'></use>
					</svg>
				</Link>
			</div>
		</div>
	)
}
